module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 143
// module chunks = 2 3 4 5 6 7 8 9 10 20 21 24